import { render, staticRenderFns } from "./DashboardInsuranceTable.vue?vue&type=template&id=768d109c&"
import script from "./DashboardInsuranceTable.vue?vue&type=script&lang=js&"
export * from "./DashboardInsuranceTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardInsuranceTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports